import React, { useEffect, useState } from 'react';
import HealthChart from './HeathChart'
import CaloriesChart from './CaloriesChart'
import Sports from './Sports'
import Psychiatric from './Psychiatric'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons'
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { SERVER_URL } from '../../../../config';

import Muscular from './Muscular'
import Injuries from './Injuries'
import Behaviour from './Behaviour'
import FullDNAReport from './FullDNAReport';


export default function MyDNA({ soccerReportData }) {

    const [behavioralData, setBehavioralData] = useState([]);
    const [injuryData, setInjuryData] = useState([]);
    const [muscleData, setMuscleData] = useState([]);
    const [psychiatricData, setPsychiatricData] = useState([]);
    const [sportsTraitsData, setSportsTraitsData] = useState([]);

    useEffect(() => {
        if (soccerReportData) {
            setBehavioralData(soccerReportData["Behavioural Traits"] || []);
            setInjuryData(soccerReportData["Injuries"] || []);
            setMuscleData(soccerReportData["Muscular System Traits"] || []);
            setPsychiatricData(soccerReportData["Psychiatric Traits"] || []);
            setSportsTraitsData(soccerReportData["Sports Traits"] || []);
        }
    }, [soccerReportData]);


    const [Activegraph, setActivegraph] = useState('div1')
    let token = sessionStorage.getItem('player_token')
    const navigate = useNavigate();
    const [playerData, setPlayerData] = useState([]);
    const [isOpenPopup, setOpenPopup] = useState(false);
    const [formData, setFormData] = useState({
        avgHeartBeat: "",
        vo2Max: "",
        bloodGlucose: "",
        weight: "",
        sleepCycle: "",
        calorieIntake: "",
        fatPercentage: ""
    });

    useEffect(() => {
        if (token) {
            get_player_data();
            checkPlayerData();
        }
    }, [token]);

    const get_player_data = async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/api/v2/get-player-data`, {
                headers: { Authorization: `Bearer ${token}`, }
            });
            if (response.data.status === true) {
                setPlayerData(response.data.data);
            } else {
                setPlayerData([])
            }
        } catch (error) {
            console.error("Error checking the player profile : ", error);
            if (error.response?.status === 403) {
                toast.error(`${error?.response?.data?.error?.msg}`);
                setTimeout(() => {
                    toast.dismiss()
                    navigate('/player/Login');
                }, 1500);
            }
        }
    }

    const handleActivetab = (tab) => {
        setActivegraph(tab)
    }

    const checkPlayerData = async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/api/v2/get-player-health-data`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.status && response.data.data) {
                setOpenPopup(false);
                setFormData(response.data.data);
            } else {
                setOpenPopup(true);
            }
        } catch (error) {
            console.error("Error checking player health data:", error);
            if (error?.response?.data?.status === false) {
                setOpenPopup(true);
            }
        }
    };

    const validateInputs = () => {
        if (!formData.avgHeartBeat || isNaN(formData.avgHeartBeat) || formData.avgHeartBeat <= 0) {
            toast.error("Enter a valid heart rate (BPM)");
            return false;
        } else if (!formData.vo2Max || isNaN(formData.vo2Max) || formData.vo2Max <= 0) {
            toast.error("Enter a valid VO2 Max");
            return false;
        } else if (!formData.bloodGlucose || isNaN(formData.bloodGlucose) || formData.bloodGlucose <= 0) {
            toast.error("Enter a valid blood glucose level");
            return false;
        } else if (!formData.weight || isNaN(formData.weight) || formData.weight <= 0) {
            toast.error("Enter a valid weight (kg)");
            return false;
        } else if (!formData.sleepCycle || isNaN(formData.sleepCycle) || formData.sleepCycle <= 0) {
            toast.error("Enter a valid sleep cycle (hours)");
            return false;
        } else if (!formData.calorieIntake || isNaN(formData.calorieIntake) || formData.calorieIntake <= 0) {
            toast.error("Enter a valid calorie intake (Kcal)");
            return false;
        } else if (!formData.fatPercentage || isNaN(formData.fatPercentage) || formData.fatPercentage < 0 || formData.fatPercentage > 100) {
            toast.error("Enter a valid fat percentage (0-100%)");
            return false;
        }

        return true;
    };

    const handleSubmit = async () => {
        if (!validateInputs()) return;

        try {
            const response = await axios.post(`${SERVER_URL}/api/v2/store-player-health-data`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.status) {
                toast.success("Data saved successfully!");
                checkPlayerData()
            } else {
                toast.error("Failed to save data.");
            }
        } catch (error) {
            console.error("Error saving player data:", error);
            toast.error("An error occurred while saving.");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const DownloadDNAreport = () => {
        setActivegraph('div6')
    };
    return (
        <div className='bg-[#D4D4D4]/10 rounded-tl-xl flex flex-col flex-grow py-5'>
            {isOpenPopup && (
                <div className="bg-black/50 backdrop-blur-md fixed inset-0 z-50 flex lg:justify-center lg:items-center w-full py-5 lg:py-0">
                    <div className="overflow-y-auto relative p-5 lg:p-10 w-[90%] lg:w-[65%] bg-[#252728]/50 backdrop-blur-sm mx-auto rounded-xl flex flex-col gap-5 lg:gap-10 2xl:text-xl">

                        <div className="flex flex-col lg:flex-row gap-5 lg:gap-10">

                            <div className='w-[100%] lg:w-[50%] space-y-5'>
                                <div className='flex flex-col gap-2'>
                                    <label>Avg Heart Beat</label>
                                    <input
                                        name="avgHeartBeat"
                                        value={formData.avgHeartBeat}
                                        onChange={handleChange}
                                        className='bg-[#545454]/35 outline-none border rounded-md px-3 py-2 w-[100%] placeholder:text-white'
                                        placeholder='BPM'
                                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, '')}
                                    />
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <label>VO2 Max</label>
                                    <input
                                        name="vo2Max"
                                        value={formData.vo2Max}
                                        onChange={handleChange}
                                        className='bg-[#545454]/35 outline-none border rounded-md px-3 py-2 w-[100%] placeholder:text-white'
                                        placeholder='ml/kg/min'
                                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, '')}
                                    />
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <label>Blood Glucose</label>
                                    <input
                                        name="bloodGlucose"
                                        value={formData.bloodGlucose}
                                        onChange={handleChange}
                                        className='bg-[#545454]/35 outline-none border rounded-md px-3 py-2 w-[100%] placeholder:text-white'
                                        placeholder='mg/hg'
                                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, '')}
                                    />
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <label>Weight</label>
                                    <input
                                        name="weight"
                                        value={formData.weight}
                                        onChange={handleChange}
                                        className='bg-[#545454]/35 outline-none border rounded-md px-3 py-2 w-[100%] placeholder:text-white'
                                        placeholder='Kg'
                                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, '')}
                                    />
                                </div>
                            </div>

                            <div className='w-[100%] lg:w-[50%] space-y-5'>
                                <div className='flex flex-col gap-2'>
                                    <label>Sleep Cycle</label>
                                    <input
                                        name="sleepCycle"
                                        value={formData.sleepCycle}
                                        onChange={handleChange}
                                        className='bg-[#545454]/35 outline-none border rounded-md px-3 py-2 w-[100%] placeholder:text-white'
                                        placeholder='Sleep Cycle hours'
                                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, '')}
                                    />
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <label>Calorie Intake</label>
                                    <input
                                        name="calorieIntake"
                                        value={formData.calorieIntake}
                                        onChange={handleChange}
                                        className='bg-[#545454]/35 outline-none border rounded-md px-3 py-2 w-[100%] placeholder:text-white'
                                        placeholder='K cal'
                                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9,]/g, '')}
                                    />
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <label>Fat %</label>
                                    <input
                                        name="fatPercentage"
                                        value={formData.fatPercentage}
                                        onChange={handleChange}
                                        className='bg-[#545454]/35 outline-none border rounded-md px-3 py-2 w-[100%]'
                                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, '')}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='w-full flex justify-center mt-5 pb-3'>
                            <button
                                onClick={handleSubmit}
                                className='bg-blue-500 text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-blue-600 transition'
                            >
                                Submit
                            </button>
                        </div>

                    </div>
                </div>
            )}

            <div className='flex flex-col lg:flex-row gap-5 lg:gap-7 px-5 lg:px-10'>
                <div className='w-[100%] lg:w-[30%] grid gap-3'>
                    <div className='px-5 py-3 rounded-xl bg-[#FFFFFF]/10 font-medium flex items-center justify-between'>
                        <div>
                            <h1 className='text-xl'>Eaten</h1>
                            <p><span className='text-[#069EA3]'>{formData?.calorieIntake} cal</span> of 4000 cal</p>
                            <p className='text-sm mt-2'>{Number(formData?.calorieIntake) > 4000 ? 0 : 4000 - Number(formData?.calorieIntake)} cal left</p>
                        </div>
                        <div>
                            <CaloriesChart from={Number(formData?.calorieIntake) > 4000 ? 4000 : Number(formData?.calorieIntake)} to={4000} />
                        </div>
                    </div>
                    <div className='px-5 py-3 rounded-xl bg-[#FFFFFF]/10 font-medium '>
                        <div className='border-b pb-2 flex items-center justify-between'>
                            <div>
                                <h1 className='text-lg'>Activity</h1>
                                <p className='font-bold text-xl'>2032</p>
                                <p className='text-sm mt-2 text-[#9E9E9E]'>Steps</p>
                            </div>
                            <img src='/assets/others/Stepsgraph.svg'></img>
                        </div>
                        <div className='pt-2 flex items-center justify-between'>
                            <div>
                                <h1 className='text-lg'>Water</h1>
                                <p className='font-bold text-xl'>4 GL</p>
                                <p className='text-sm mt-2 text-[#9E9E9E]'>8 glasses per day</p>
                            </div>
                            <img src='/assets/others/Watergraph.svg'></img>
                        </div>
                    </div>
                </div>
                <div className='w-[100%] lg:w-[40%] grid content-around'>
                    <HealthChart />
                    <div className='flex justify-center gap-5'>
                        <button className='py-3 w-[45%] bg-[#A3B6FF]/40 rounded-lg font-medium'>Add Data</button>
                        <button className='py-3 w-[45%] bg-[#A3B6FF]/40 rounded-lg font-medium'>Book  Consultation</button>
                    </div>
                </div>
                <div className='w-[100%] lg:w-[30%] grid gap-3'>
                    <div className='px-5 py-3 rounded-xl bg-[#FFFFFF]/10 font-medium'>
                        <div className='flex items-center justify-between'>
                            <div>
                                <h1 className='text-lg'>Blood Glucose</h1>
                                <p className='font-bold text-xl'>{Number(formData?.bloodGlucose)?.toFixed(0)}</p>
                                <p className='font-normal'>mg/dl</p>
                            </div>
                            <img src='/assets/others/Blooddrop.svg'></img>
                        </div>
                        <img src='/assets/others/Bloodgraph.svg' className='mt-2 mx-auto'></img>
                        <p className='mt-2 text-sm'>After fasting</p>
                    </div>
                    <div className='px-5 py-3 rounded-xl bg-[#FFFFFF]/10 font-medium flex items-center justify-between'>
                        <div>
                            <h1 className='text-lg'>Heart</h1>
                            <p className='font-bold text-xl'>{Number(formData?.avgHeartBeat)?.toFixed(0)}</p>
                            <p className='text-sm mt-2 text-[#9E9E9E]'>bpm</p>
                        </div>
                        <img src='/assets/others/Heartgraph.svg'></img>
                    </div>
                </div>
            </div>

            <div className='mt-10 bg-[#A3B6FF]/20 rounded-lg flex flex-wrap justify-center gap-5 font-medium'>
                <button
                    onClick={() => handleActivetab('div1')}
                    className={`px-3 lg:w-[15%] py-2 2xl:py-3 cursor-pointer 
                ${Activegraph === 'div1' ? 'bg-gradient-to-r from-[#A70E9D] to-[#5C1FE2] shadow-md rounded-full shadow-black/25' : ''}`}>
                    Sports
                </button>

                <button
                    onClick={() => handleActivetab('div2')}
                    className={`px-3 lg:w-[15%] py-2 2xl:py-3 cursor-pointer 
                ${Activegraph === 'div2' ? 'bg-gradient-to-r from-[#A70E9D] to-[#5C1FE2] shadow-md rounded-full shadow-black/25' : ''}`}>
                    Psychiatric
                </button>

                <button
                    onClick={() => handleActivetab('div3')}
                    className={`px-3 lg:w-[15%] py-2 2xl:py-3 cursor-pointer 
                ${Activegraph === 'div3' ? 'bg-gradient-to-r from-[#A70E9D] to-[#5C1FE2] shadow-md rounded-full shadow-black/25' : ''}`}>
                    Muscular System
                </button>

                <button
                    onClick={() => handleActivetab('div4')}
                    className={`px-3 lg:w-[15%] py-2 2xl:py-3 cursor-pointer 
                ${Activegraph === 'div4' ? 'bg-gradient-to-r from-[#A70E9D] to-[#5C1FE2] shadow-md rounded-full shadow-black/25' : ''}`}>
                    Injuries
                </button>

                <button
                    onClick={() => handleActivetab('div5')}
                    className={`px-3 lg:w-[15%] py-2 2xl:py-3 cursor-pointer 
                ${Activegraph === 'div5' ? 'bg-gradient-to-r from-[#A70E9D] to-[#5C1FE2] shadow-md rounded-full shadow-black/25' : ''}`}>
                    Behavioural
                </button>

            </div>


            <div className='mt-10'>
                {Activegraph === 'div1' && (
                    sportsTraitsData.length > 0 ? (
                        <Sports sportsTraitsData={sportsTraitsData} DownloadDNAreport={DownloadDNAreport} />
                    ) : (
                        <div className="text-center text-gray-400 mt-10 text-lg">Data not available</div>
                    )
                )}

                {Activegraph === 'div2' && (
                    psychiatricData.length > 0 ? (
                        <Psychiatric psychiatricData={psychiatricData} DownloadDNAreport={DownloadDNAreport} />
                    ) : (
                        <div className="text-center text-gray-400 mt-10 text-lg">Data not available</div>
                    )
                )}

                {Activegraph === 'div3' && (
                    muscleData.length > 0 ? (
                        <Muscular muscleData={muscleData} DownloadDNAreport={DownloadDNAreport} />
                    ) : (
                        <div className="text-center text-gray-400 mt-10 text-lg">Data not available</div>
                    )
                )}

                {Activegraph === 'div4' && (
                    injuryData.length > 0 ? (
                        <Injuries injuryData={injuryData} DownloadDNAreport={DownloadDNAreport} />
                    ) : (
                        <div className="text-center text-gray-400 mt-10 text-lg">Data not available</div>
                    )
                )}

                {Activegraph === 'div5' && (
                    behavioralData.length > 0 ? (
                        <Behaviour behavioralData={behavioralData} DownloadDNAreport={DownloadDNAreport} />
                    ) : (
                        <div className="text-center text-gray-400 mt-10 text-lg">Data not available</div>
                    )
                )}

                {Activegraph === 'div6' && <FullDNAReport />}
            </div>


        </div>
    )
}
